import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, MessageSquare, LogOut } from "lucide-react";

const links = [
  { path: "/admin", icon: LayoutDashboard, label: "Dashboard" },
  { path: "/admin/blog", icon: FileText, label: "Blog Posts" },
  { path: "/admin/inquiries", icon: MessageSquare, label: "Inquiries" },
];

export const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_username");
    navigate("/admin/login");
  };

  return (
    <aside data-testid="admin-sidebar" className="w-64 bg-[#0F172A] text-white admin-sidebar flex flex-col">
      <div className="p-6 border-b border-white/10">
        <p className="text-sm font-sans font-medium">KF Prints Admin</p>
        <p className="text-xs font-sans text-white/50 mt-1">{localStorage.getItem("admin_username")}</p>
      </div>
      <nav className="flex-1 py-4">
        {links.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            data-testid={`admin-nav-${link.label.toLowerCase().replace(/\s/g, '-')}`}
            className={`flex items-center gap-3 px-6 py-3 text-sm font-sans transition-colors duration-200 ${
              location.pathname === link.path ? "bg-white/10 text-[#C5A059]" : "text-white/60 hover:text-white hover:bg-white/5"
            }`}
          >
            <link.icon size={18} />
            {link.label}
          </Link>
        ))}
      </nav>
      <button onClick={handleLogout} data-testid="admin-logout-btn" className="flex items-center gap-3 px-6 py-4 text-sm font-sans text-white/40 hover:text-white border-t border-white/10">
        <LogOut size={18} />
        Logout
      </button>
    </aside>
  );
};
